


// InputField.js

import React from 'react'
import '../../styles/text/InputField.css';

const InputField = ({ title, placeholder, type, fieldName, value, onChange, error }) => {
    
    return (
        <>
            <div className='input-field-container'>
                <div className='input-field-title'>
                    <p>{title}</p>
                </div>
                <div className='input-field-input'>
                    {type === 'textarea' ? (

                        <textarea
                            title={title}
                            name={fieldName}
                            placeholder={error || placeholder}
                            value={value}
                            onChange={onChange}
                            className={error ? 'input-error' : ''}
                        />
                    ) : (
                        <input
                            title={title}
                            name={fieldName}
                            placeholder={error || placeholder}
                            type={type || 'text'}
                            value={value}
                            onChange={onChange}
                            className={error ? 'input-error' : ''}
                        />
                    ) }
                </div>
                
            </div>
        </>
    );
}


export default InputField
